const items = [
  "Anamnesi corporea",
  "Scheda su misura",
  "Piano alimentare",
  "File Excel interattivo",
  "Rinnovo gratuito",
  "No scuse",
];

export default function KineticTicker() {
  return (
    <section className="relative py-8 overflow-x-clip" data-testid="kinetic-ticker">
      <div className="w-[110%] -ml-[5%] -rotate-1 bg-blood py-3.5 overflow-hidden shadow-[0_10px_40px_-10px_rgba(229,9,20,0.5)]">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((copy) => (
            <div key={copy} aria-hidden={copy === 1} className="flex items-center whitespace-nowrap">
              {items.map((t) => (
                <span key={`${copy}-${t}`} className="flex items-center font-display font-black uppercase text-2xl sm:text-3xl text-black tracking-tight">
                  <span className="px-6">{t}</span>
                  <span className="w-2.5 h-2.5 bg-black rotate-45 inline-block shrink-0" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
